import { Component, DestroyRef, effect, inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import {MatPaginator, MatPaginatorModule} from '@angular/material/paginator';
import {MatSort, MatSortModule} from '@angular/material/sort';
import { MatTableModule} from '@angular/material/table';
import {  MatInputModule } from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import { Genre } from '@shared/interfacres/genre';
import { DatePipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';

import { debounceTime, firstValueFrom } from 'rxjs';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatButton } from '@angular/material/button';

import { MatDialog } from '@angular/material/dialog';

import { MatProgressBar } from '@angular/material/progress-bar';
import { MatCheckbox } from '@angular/material/checkbox';

import {SelectionModel} from '@angular/cdk/collections';
import { ConfirmationDialog } from '@shared/components/confirmation-dialog/confirmation-dialog';
import { EditSubgenreDialog } from './edit-subgenre-dialog/edit-subgenre-dialog';
import { SubGenresManagerStore } from '@data-access/manager/stores/subgenres-manager.store';
import { IconInput } from '@shared/components/icon-input/icon-input';


@Component({
  selector: 'app-subgenres',
  templateUrl: './subgenres.html',
  styleUrl: './subgenres.scss',

  imports: [MatFormFieldModule, MatInputModule, MatTableModule, MatSortModule, MatPaginatorModule,
    DatePipe, MatIcon, ReactiveFormsModule, MatProgressBar, MatCheckbox, MatButton, IconInput],
})
export class Subgenres implements OnInit, OnDestroy {
  displayedColumns: string[] = ['id', 'name', 'updated_at', 'actions'];
  dataSource: Genre[] = [];
  total = 0;

  searchValue = new FormControl('');

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  selection = new SelectionModel<number>(
    true,
    []
  );

  readonly store = inject(SubGenresManagerStore);

  private destroyRef = inject(DestroyRef);
  readonly dialog = inject(MatDialog);

  constructor(
  ) {

    effect(() => {
      this.dataSource = this.store.items();
      this.total = this.store.total();
    });
  }

  ngOnInit(): void {
    this.searchValue.valueChanges
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        debounceTime(400),
      )
      .subscribe(input => {
        this.store.getByName(input as string);
      })
    this.store.setFilter('updated_at', 'desc');
  }

  changePage(page: {pageIndex: number; pageSize: number}) {
    this.store.setPagination(page.pageIndex + 1, page.pageSize);
  }

  sortChange(event: {active: string; direction: string}) {
    this.store.setFilter(event.active, event.direction as 'asc' | 'desc');
  }

  async openDialog(item: Genre) {
    const dialogRef = this.dialog.open(EditSubgenreDialog, {
      data: item,
      disableClose: true,
      width: '500px',
      panelClass: 'admin-dialog',
      backdropClass: 'admin-dialog-backdrop'
    });

    const result = await firstValueFrom(dialogRef.afterClosed());
    if (result !== undefined) {
      this.store.update(item.id, result);
    }
  }

  async add() {

    const dialogRef = this.dialog.open(EditSubgenreDialog, {
      data: null,
      disableClose: true,
      width: '500px',
      panelClass: 'admin-dialog',
      backdropClass: 'admin-dialog-backdrop'
    });

    const result = await firstValueFrom(dialogRef.afterClosed());
    if (result !== undefined) {
      this.store.create(result);
    }
  }

  async bulkDelete() {
    const dialogRef = this.dialog.open(ConfirmationDialog, {
      data: {
        title: 'Delete selected',
        message: 'Are you sure you want to delete selected genres?'
      },
      disableClose: true,
      panelClass: 'admin-dialog',
      backdropClass: 'admin-dialog-backdrop'
    });

    const result = await firstValueFrom(dialogRef.afterClosed());
    if (result) {

      this.store.delete(this.selection.selected);
      this.selection.clear();
    }
  }

  ngOnDestroy() {
    this.store.clearCriteria();
  }
}
